"use strict";

var Backbone = require("backbone");
var ReaderView = require("./views/reader-view");
var $ = require("jquery");
var _ = require("underscore");

var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");

var debug = require("debug")("router"); //https://github.com/visionmedia/debug

// Router
var Router = Backbone.Router.extend({

    routes: {
        "*querystring": "reader"
    },

    initialize: function(options) {
        this.app = options.app;
    },

    reader: function(querystring) {

        $("#app-reader").show();
        $("#error-404").hide();

        if (this.view) {
            this.view.close();
        }

        var publication_title,
            document_date,
            publication_id,
            document_id,
            page,
            from,
            fit,
            highlight,
            article_id,
            index;

        //
        // urls possibles:
        //  131/100001
        //  131/100001/1
        //  131/100001/1?from=xxx
        //  le-figaro/18-mars-1893/131/100001
        //  le-figaro/18-mars-1893/131/100001/1
        //  le-figaro/18-mars-1893/131/100001/1/9caf84f846d1f58947a9239faa88e52c
        //  le-figaro/18-mars-1893/131/100001/1?fit=998,1105,517,701
        //  trop compliqué à exprimer pour le router backbone, donc on fait à la main
        //

        var url_split = querystring.split("?");
        var path_split = url_split[0].split("/");

        if (path_split.length == 6 || path_split.length == 5 || path_split.length == 4) {
            publication_title = path_split[0];
            document_date = path_split[1];
            publication_id = path_split[2];
            document_id = path_split[3];
            page = path_split[4];
            article_id=path_split[5];

        } else if (path_split.length == 2 || path_split.length == 3) {
            publication_id = path_split[0];
            document_id = path_split[1];
            page = path_split[2];
        } else {
            return this.error404();
        }

        if (url_split.length == 2) {
            from = url_split[1];
        }

        //from peut aussi être dans la query string globale
        var query_obj = UrlUtil.parseQueryString(window.location.search.replace("?", ""), ["from", "fit", "highlight","index"]);
        if (query_obj.from) {
            from = query_obj.from;
        }

        if (query_obj.fit) {
            var fit_array = query_obj.fit.split(".");
            if (fit_array.length == 4) {
                fit = {
                    x: parseInt(fit_array[0]),
                    y: parseInt(fit_array[1]),
                    width: parseInt(fit_array[2]),
                    height: parseInt(fit_array[3])
                };
            }
        }

        if (query_obj.highlight) {
            var highlight_array = query_obj.highlight.split(".");
            if (highlight_array.length == 4) {
                highlight = {
                    x: parseInt(highlight_array[0]),
                    y: parseInt(highlight_array[1]),
                    width: parseInt(highlight_array[2]),
                    height: parseInt(highlight_array[3])
                };
            }
        }

        if (!_.isUndefined(query_obj.index)) {
            index = parseInt(query_obj.index);
        }

        debug("reader %s %s %s %s %s %s %j %j %s %s", publication_title, document_date, publication_id, document_id, page, from, fit, highlight, index);

        this.view = new ReaderView({
            app: this.app,
            routePublicationTitle: publication_title, // optionnel
            routeDocumentDate: document_date, // optionnel
            publicationId: parseInt(publication_id, 10) || 1,
            documentId: parseInt(document_id, 10) || 1,
            page: parseInt(page, 10) || 1,
            from: from, // optionnel
            fit: fit, // optionnel
            highlight: highlight, // optionnel
            articleId:article_id, // optionnel
            index: index // optionnel
        });
    },


    error404: function(invalid_route) {
        debug("error404 %s", invalid_route);
        $("#app-reader").hide();
        $("#error-404").show();
    }

});

module.exports = Router;